import { useQuery } from '@tanstack/react-query';
import {
  fetchFactoryActivity,
  fetchJob,
  fetchJobActivityTimeline,
  fetchFactoryReports,
  fetchJobReportsTimeline
} from '../api/jobsApi.js';

export function useJob(jobId) {
  return useQuery({
    queryKey: ['jobs', 'detail', jobId],
    queryFn: () => fetchJob(jobId),
    // refetchInterval: 4000
    enabled: !!jobId
  });
}

export function useFactoryActivity(limit = 100) {
  return useQuery({
    queryKey: ['redis', 'factory-activity', limit],
    queryFn: () => fetchFactoryActivity(limit),
    refetchInterval: 5000,
    staleTime: 0
  });
}

export function useJobActivityTimeline(jobId) {
  return useQuery({
    queryKey: ['jobs', 'activity-timeline', jobId],
    queryFn: () => fetchJobActivityTimeline(jobId),
    enabled: !!jobId,
    refetchInterval: 5000,
    staleTime: 0
  });
}

export function useFactoryReports(limit = 100) {
  return useQuery({
    queryKey: ['factory-reports', limit],
    queryFn: () => fetchFactoryReports(limit),
    refetchInterval: 5000,
    staleTime: 0
  });
}

export function useJobReportsTimeline(jobId) {
  return useQuery({
    queryKey: ['job-reports-timeline', jobId],
    queryFn: () => fetchJobReportsTimeline(jobId),
    enabled: !!jobId,
    refetchInterval: 5000,
    staleTime: 0
  });
}
